import { Component, Watch, mixins } from 'nuxt-property-decorator';
import { IUser } from 'sitisjs/dist/internal/sections/users/models/User';
import UserMixin from './UserMixin';

@Component
export default class ProfilePageMixin extends mixins(UserMixin) {
	username = '';
	address = '';
	phone = '';
	sex = '';
	birthday = '';
	email = '';

	@Watch('user', { immediate: true })
	onChangeUser(user: IUser): void {
		if (user) {
			this.username = user.username;
			this.address = user.address || '';
			this.phone = user.phone || '';
			this.sex = user.sexLabel || '';
			this.birthday = user.birthday || '';
			this.email = user.email || '';
		}
	}

	onLogout(): void {
		this.userLogout();
		this.$router.replace('/');
	}

	serializeForm(): unknown {
		return {
			username: this.username,
			address: this.address,
			phone: this.phone,
			sex: this.sex,
			birthday: this.birthday,
			email: this.email,
		};
	}

	submitForm(): void {
		console.log('on submit form ', this.serializeForm());
	}
}
